import { render } from "./listItemBookingComponent.vue?vue&type=template&id=b4656dbe&ts=true"
import script from "./listItemBookingComponent.vue?vue&type=script&lang=ts"
export * from "./listItemBookingComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__